import * as React from 'react';
import type { SVGProps } from 'react';
const SvgSupportBold = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns='http://www.w3.org/2000/svg' width={24} height={24} fill='none' {...props}>
    <path
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
      d='M3 13v-2a9 9 0 1 1 18 0v2M21 13v1.636c0 1.953-.738 3.826-2.05 5.207C17.637 21.224 15.857 22 14 22'
    />
    <path
      fill='currentColor'
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
      d='M21 15a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3zM3 15a2 2 0 0 0 2 2h1a2 2 0 0 0 2-2v-3a2 2 0 0 0-2-2H3zM11.143 22c-.303 0-.594-.126-.808-.352A1.23 1.23 0 0 1 10 20.8v-.6c0-.318.12-.623.335-.848.214-.226.505-.352.808-.352h1.714c.303 0 .594.126.808.352.215.224.335.53.335.848V22z'
    />
  </svg>
);
export default SvgSupportBold;
